export default "__VITE_ASSET__DaAe7S5l__"